import React, { useEffect, useState } from "react";
import { CaretUpOutlined } from "@ant-design/icons";
import { CaretDownOutlined } from "@ant-design/icons";
import { MoreOutlined } from "@ant-design/icons";
import { Input, Menu, Popover, Table, Tabs } from "antd";
import SetUserPassword from "./SetUserPassword";
import './Admin.css';
import { useSelector } from "react-redux";
import axios from "axios";
import { baseUrl } from "../../utils/envAccess";
import { handleApiError } from "../Handler/ExceptionHandler";
import ChangeEmail from "./ChangeEmail";
import { Spin } from "antd";


const AssignmentOfCare = () => {
    // const [isOpentog, setIsOpenToggle] = useState(false);
    const [isOpen, setOpen] = useState('');
    const [currAccount, setAccount] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [careProviderSource, setCareProviderSource] = useState([]);
    const [careProviderTable, setCareProviderTable] = useState([]);
    const [activeTabKey, setActiveTabKey] = useState('patients');
    const [careDataLoaded, setCareDataLoaded] = useState(false);
    const [logData, setLogData] = useState([]);
    const [logTable, setLogTable] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [providerExpandedData, setProviderExpandedData] = useState({});
    const [loadingKeys, setLoadingKeys] = useState([]); // tracks which keys are loading


    const [logPagination, setLogPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    //   const toggleTable = () => {
    //     setIsOpenToggle(prev => !prev);
    //   };


    const [searchParams, setSearchParams] = useState({
        account: '',
        firstName: '',
        lastName: ''
    });

      const [patientsPagination, setPatientsPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
      });

    const [carePagination, setCarePagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    const userAuth = useSelector((state) => state?.authentication?.userAuth);

    const MenuPopover = ({ account }) => (
        <Popover
            placement="rightTop"
            content={<ContentMenu account={account} />}
            trigger='click'
        >
            <MoreOutlined />
        </Popover>
    );

    const ContentMenu = ({ account }) => (
        <Menu
            mode="inline"
            items={[
                {
                    key: 'application',
                    label: "View Application",
                    onClick: () => { setAccount(account); setOpen('Application'); }
                },
                {
                    key: 'password',
                    label: "Reset Password",
                    onClick: () => { setAccount(account); setOpen('Password'); }
                },
                {
                    key: 'switch',
                    label: "Change Email",
                    onClick: () => { setAccount(account); setOpen('Email'); }
                }
            ]}
        />
    );

    //   const handleTableChange = (pagination, filters, sorter) => {
    //     setPagination(pagination);
    //   };

    const handleCareTableChange = (pagination, filters, sorter) => {
        setCarePagination(pagination);
    };

    const columns = [
        {
            title: 'Account #',
            dataIndex: 'account',
            key: 'account',
            sorter: (a, b) => a.account.localeCompare(b.account),
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: (a, b) => a.firstName.localeCompare(b.firstName),
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            sorter: (a, b) => a.lastName.localeCompare(b.lastName),
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            filters: [
                { text: 'Patient', value: 'Patient' },
                { text: 'Doctor', value: 'Doctor' },
                { text: 'Nurse', value: 'Nurse' }
            ],
            onFilter: (value, record) => record.role === value,
        },
        {
            title: 'Activated',
            dataIndex: 'activated',
            key: 'activated',
            filters: [
                { text: 'Active', value: 'Active' },
                { text: 'Waiting for Approval', value: 'Waiting for Approval' }
            ],
            onFilter: (value, record) => record.activated === value,
        },
        {
            title: 'Accepting Patients?',
            dataIndex: 'acceptingPatients',
            key: 'acceptingPatients',
            filters: [
                { text: 'Yes', value: 'Yes' },
                { text: 'No', value: 'No' }
            ],
            onFilter: (value, record) => record.acceptingPatients === value,
        },
        {
            title: '',
            key: 'expand',
            render: (text, record) => (
                <span onClick={() => handleProviderExpand(record)}>
                    {expandedRowKeys.includes(record.key) ? <CaretUpOutlined /> : <CaretDownOutlined />}
                </span>
            )
        }
    ];

    const logColumns = [
        {
            title: 'Provider Name',
            dataIndex: 'providername',
            key: 'providername',
            sorter: (a, b) => (a.providername || '').localeCompare(b.providername || ''),
        },
        {
            title: 'Patient Name',
            dataIndex: 'patientname',
            key: 'patientname',
            sorter: (a, b) => (a.patientname || '').localeCompare(b.patientname || ''),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                // Assuming 0 = Unassigned, 1 = Assigned (adjust if different)
                return status === 1 ? (
                    <span style={{ color: 'green', fontWeight: 'bold' }}>Assigned</span>
                ) : (
                    <span style={{ color: 'red', fontWeight: 'bold' }}>Unassigned</span>
                );
            },
            filters: [
                { text: 'Assigned', value: 1 },
                { text: 'Unassigned', value: 0 }
            ],
            onFilter: (value, record) => record.status === value,
        },
        {
            title: 'Admin Name',
            dataIndex: 'adminName',
            key: 'adminName',
            sorter: (a, b) => (a.adminName || '').localeCompare(b.adminName || ''),
        },
        {
            title: 'Created On',
            dataIndex: 'createdOn',
            key: 'createdOn',
            sorter: (a, b) => new Date(a.createdOn) - new Date(b.createdOn),
            render: (date) => {
                if (!date) return 'N/A';
                return new Date(date).toLocaleString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            },
        },
        {
            title: 'Approved On',
            dataIndex: 'approvedOn',
            key: 'approvedOn',
            sorter: (a, b) => new Date(a.approvedOn || 0) - new Date(b.approvedOn || 0),
            render: (date) => {
                if (!date) return 'N/A';
                return new Date(date).toLocaleString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            },
        },
    ];

    const providerExpandedColumns = [
        { title: 'Patient Name', dataIndex: 'patientName', key: 'patientName' },
        { title: 'Account #', dataIndex: 'account', key: 'account' },
        { title: 'Status', dataIndex: 'status', key: 'status' },
    ];

    const handleProviderExpand = async (record) => {
        const key = record.key;
    
        // Collapse if already expanded
        if (expandedRowKeys.includes(key)) {
            setExpandedRowKeys(prev => prev.filter(k => k !== key));
            return;
        }
    
        // If data is already cached, just expand
        if (providerExpandedData[key]) {
            setExpandedRowKeys(prev => [...prev, key]);
            return;
        }
    
        // Show loading spinner
        setLoadingKeys(prev => [...prev, key]);
    
        try {
            const children = await getProviderPatients(key);
    
            // Cache was updated in getProviderPatients
            setExpandedRowKeys(prev => [...prev, key]);
    
            // Show message only if no data returned
            if (!children || children.length === 0) {
               // message.info("No patients assigned to this provider.");
            }
    
        } catch (err) {
            console.error("Error fetching patients", err);
        } finally {
            setLoadingKeys(prev => prev.filter(k => k !== key));
        }
    };

    const getProviderPatients = async (doctorRef) => {
        if (providerExpandedData[doctorRef]) {
            return providerExpandedData[doctorRef]; // return cached
        }
        const config = {
            headers: { Authorization: `Bearer ${userAuth?.obj?.token}` },
        };

        try {
            const response = await axios.get(`${baseUrl}Admin/GetPatientByDoctor/${doctorRef}/0/50`, config);
            const result = response.data;

            const formatted = result?.map((patient, index) => ({
                key: `${doctorRef}-patient-${index}`,
                patientName: `${patient.firstname || ''} ${patient.lastname || ''}`,
                account: patient.userRef || '',
                status: patient.patientStat || 'Active',
            })) || [];

            setProviderExpandedData(prev => ({ ...prev, [doctorRef]: formatted }));

            return formatted;
        } catch (error) {
            handleApiError(error);
            return [];
        }
    };

    const handleLogTableChange = (pagination, filters, sorter) => {
        setLogPagination(pagination);
    };
    const getExpandedData = (record) => {
        return record.providers?.map((provider, index) => ({
            key: `${record.key}-provider-${index}`,
            providerName: provider.providerName || '',
            providerRole: provider.providerRole || 'N/A',
            statusRemark: provider.statusRemark || '',
        })) || [];
    };


    // Fetch Patients
    useEffect(() => {
        const fetchPatients = async () => {
            const config = {
                headers: { Authorization: `Bearer ${userAuth?.obj?.token}` },
            };
            try {
                const response = await axios(`${baseUrl}Admin/GetPatientList/0/100`, config);
                return response.data;
            } catch (error) {
                handleApiError(error);
                return [];
            }
        };



        fetchPatients().then((res) => {
            if (!Array.isArray(res)) return;
            const formatted = res.map((user) => {
                const account = user.userRef || '';
                return {
                    key: account,
                    account: account,
                    firstName: user.firstname || '',
                    lastName: user.lastname || '',
                    role: 'Patient',
                    activated: user.patientStat || 'Active',
                    acceptingPatients: 'Yes',
                    menu: <MenuPopover account={account} />,
                    providers: user.providers || [],
                };
            });
        
            setDataSource(formatted);
            setPatientsPagination((prev) => ({ ...prev, total: formatted.length })); // ✅ set total
        });        
    }, [userAuth]);

    const handlePatientsTableChange = (pagination, filters, sorter) => {
        setPatientsPagination(pagination);
    };
    

    // Fetch Log Assignment/Unassignment data
    useEffect(() => {
        const fetchLogData = async () => {
            const config = {
                headers: { Authorization: `Bearer ${userAuth?.obj?.token}` },
            };
            try {
                const response = await axios.get(`${baseUrl}Admin/GetProviderPatient`, config);
                const res = response.data;

                if (!Array.isArray(res)) return;

                const formatted = res.map((item, index) => ({
                    key: `log-${index}`,
                    providername: item.providername || '',
                    patientname: item.patientname || '',
                    status: item.status,
                    adminName: item.adminName || '',
                    createdOn: item.createdOn,
                    approvedOn: item.approvedOn,
                }));

                setLogData(formatted);
                setLogPagination((prev) => ({ ...prev, total: formatted.length }));
            } catch (error) {
                handleApiError(error);
            }
        };

        if (activeTabKey === 'log') {
            fetchLogData();
        }
    }, [activeTabKey, userAuth]);


    const handleExpand = (key) => {
        setExpandedRowKeys((prevKeys) =>
            prevKeys.includes(key)
                ? prevKeys.filter(k => k !== key)
                : [...prevKeys, key]
        );
    };
    // Fetch Care Providers
    useEffect(() => {
        const fetchCareProviders = async () => {
            const config = {
                headers: { Authorization: `Bearer ${userAuth?.obj?.token}` },
            };
            try {
                const response = await axios(`${baseUrl}Admin/GetCareGiverList/0/100`, config);
                const res = response.data;

                if (!Array.isArray(res)) return;

                const formatted = res.map((user) => {
                    const account = user.userRef || '';
                    return {
                        key: account,
                        account: account,
                        firstName: user.firstname || '',
                        lastName: user.lastname || '',
                        role: 'Care Provider',
                        activated: user.patientStat || 'Active',
                        acceptingPatients: 'Yes',
                        menu: <MenuPopover account={account} />,
                    };
                });

                setCareProviderSource(formatted);
                setCarePagination((prev) => ({ ...prev, total: formatted.length }));
                setCareDataLoaded(true);
            } catch (error) {
                handleApiError(error);
            }
        };

        // Only load data when Care Provider tab is clicked
        if (activeTabKey === 'providers' && !careDataLoaded) {
            fetchCareProviders();
        }
    }, [activeTabKey, userAuth, careDataLoaded]);


    // Search Filtering
    useEffect(() => {
        const filterRecords = (records) =>
            records.filter(record => {
                const accountMatch = searchParams.account
                    ? record.account?.toLowerCase().includes(searchParams.account.toLowerCase())
                    : true;
                const firstNameMatch = searchParams.firstName
                    ? record.firstName?.toLowerCase().includes(searchParams.firstName.toLowerCase())
                    : true;
                const lastNameMatch = searchParams.lastName
                    ? record.lastName?.toLowerCase().includes(searchParams.lastName.toLowerCase())
                    : true;
                return accountMatch && firstNameMatch && lastNameMatch;
            });

        const filterLogRecords = (records) =>
            records.filter(record => {
                const providerMatch = searchParams.firstName
                    ? record.providername?.toLowerCase().includes(searchParams.firstName.toLowerCase())
                    : true;
                const patientMatch = searchParams.lastName
                    ? record.patientname?.toLowerCase().includes(searchParams.lastName.toLowerCase())
                    : true;
                return providerMatch && patientMatch;
            });

        setTableData(filterRecords(dataSource));
        setCareProviderTable(filterRecords(careProviderSource));
        setLogTable(filterLogRecords(logData));

    }, [searchParams, dataSource, careProviderSource, logData]);

    const expandedColumns = [
        { title: 'Provider Name', dataIndex: 'providerName', key: 'providerName' },
        { title: 'Provider Role', dataIndex: 'providerRole', key: 'providerRole' },
        { title: 'Status', dataIndex: 'statusRemark', key: 'statusRemark' },
    ];


    const items = [
        {
            label: 'Patients',
            key: 'patients',
            children: (
                <Table
                    dataSource={tableData}
                    columns={columns}
                    pagination={patientsPagination}
                    onChange={handlePatientsTableChange}
                    expandable={{
                        expandedRowRender: (record) => (
                            <Table
                                columns={expandedColumns}
                                dataSource={getExpandedData(record)}
                                pagination={false}
                                rowKey="key"
                            />
                        ),
                        rowExpandable: () => true,
                        expandedRowKeys: expandedRowKeys,
                        onExpand: (expanded, record) => handleExpand(record.key),
                        expandIconColumnIndex: -1
                    }}
                />


            )
        },
        {
            label: 'Care Providers',
            key: 'providers',
            children: (
                <Table
                    dataSource={careProviderTable}
                    columns={columns}
                    pagination={carePagination}
                    onChange={handleCareTableChange}
                    expandable={{
                        expandedRowRender: (record) => {
                            const data = providerExpandedData[record.account];
                            if (loadingKeys.includes(record.key)) {
                                return (
                                    <div style={{ padding: '1rem', textAlign: 'center' }}>
                                        <Spin tip="Loading patients..." />
                                    </div>
                                );
                                
                            }
                    
                            return (
                                <Table
                                    columns={providerExpandedColumns}
                                    dataSource={data || []}
                                    pagination={false}
                                    rowKey="key"
                                />
                            );
                        },
                        rowExpandable: () => true,
                        expandedRowKeys: expandedRowKeys,
                        expandIconColumnIndex: -1,
                    }}
                    

                />
            )
        },

        {
            label: 'Log Assignment/Unassignment',
            key: 'log',
            children: (
                <Table
                    dataSource={logTable}
                    columns={logColumns}
                    pagination={logPagination}
                    onChange={handleLogTableChange}
                />
            )
        }
    ];


    return (
        <div style={{ margin: '2rem' }}>
            <div style={{ marginBottom: '1rem' }}>
                <h3 className="h3-admin-title">Users</h3>
                <div id="searchWrapper" style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                    <Input
                        placeholder="Search by Account #"
                        value={searchParams.account}
                        onChange={(e) => setSearchParams(prev => ({ ...prev, account: e.target.value }))}
                    />
                    <Input
                        placeholder="Search by First Name"
                        value={searchParams.firstName}
                        onChange={(e) => setSearchParams(prev => ({ ...prev, firstName: e.target.value }))}
                    />
                    <Input
                        placeholder="Search by Last Name"
                        value={searchParams.lastName}
                        onChange={(e) => setSearchParams(prev => ({ ...prev, lastName: e.target.value }))}
                    />
                </div>
            </div>

            <Tabs
                items={items}
                activeKey={activeTabKey}
                onChange={(key) => setActiveTabKey(key)}
            />


            <SetUserPassword isOpen={isOpen} setOpen={setOpen} account={currAccount} />
            <ChangeEmail isOpen={isOpen} setOpen={setOpen} account={currAccount} />
        </div>
    );
}

export default AssignmentOfCare;
